import { css } from "@emotion/css"
import { useCallback, useState } from "react"

import Button from "@p-ban/common/src/components/html/Button"
import Image from "@p-ban/common/src/components/html/Image"
import ImageButton from "@p-ban/common/src/components/html/ImageButton"
import Spacer from "@p-ban/common/src/components/layout/Spacer"
import useBool from "@p-ban/common/src/hooks/useBool"
import useOnEnterKeyDown from "@p-ban/common/src/hooks/useOnEnterKeyDown"

import img from "./search.png"
import searchButton from "./searchButton.png"
import imgHover from "./searchHover.png"

const Search = () => {
  const [isOpen, , , toggle] = useBool(false)

  return (
    <div className={styles.wrapper}>
      <Button
        onClick={toggle}
        className={styles.button.default}
        render={({ isHovered }) => (
          <>
            <Image src={isHovered ? imgHover : img} width={14} height={16} alt="" className={styles.button.image} />
            <Spacer size={8} />
            検索
          </>
        )}
      />
      {isOpen && <SearchField />}
    </div>
  )
}

export default Search

const SearchField = () => {
  const [searchWord, setSearchWord] = useState("")

  const search = useCallback(() => {
    window.open(`https://www.google.com/search?q=site:www.p-ban.com+${searchWord}`)
  }, [searchWord])

  const onChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchWord(e.target.value)
  }, [])

  const onKeyDown = useOnEnterKeyDown(search)

  return (
    <div className={styles.searchField.container}>
      <input
        type="text"
        className={styles.searchField.input}
        placeholder="検索ワード入力"
        value={searchWord}
        onChange={onChange}
        onKeyDown={onKeyDown}
      />
      <ImageButton
        src={searchButton}
        alt="検索"
        className={styles.searchField.button}
        hoverClassName={styles.searchField.buttonHover}
        onClick={search}
      />
    </div>
  )
}

const styles = {
  wrapper: css`
    position: relative;
    display: inline-block;
  `,
  button: {
    default: css`
      display: flex;
      align-items: center;
      height: 19px;

      font-size: 16px;
      color: #666;
      text-align: center;
      cursor: pointer;
      background-color: #fff;
      border: none;
      &:hover {
        text-decoration: underline;
      }
    `,
    image: css`
      display: block;
    `,
  },
  searchField: {
    container: css`
      position: absolute;
      z-index: 2;
      display: flex;
      padding: 10px;

      background-color: #fff;
      border: 1px solid #eeeeee;
    `,
    input: css`
      height: 39px;
      padding: 9px;
      font-family: inherit;
      font-size: 15px;
    `,
    button: css`
      height: 39px;
      border: 1px solid #bfbfbf;
    `,
    buttonHover: css`
      opacity: 0.7;
    `,
  },
}
